// extracted by mini-css-extract-plugin
module.exports = {"addButtonWrapper":"ContactPersons_addButtonWrapper__2w_3-","addButton":"ContactPersons_addButton__2pWzT","button":"ContactPersons_button__3PxvY"};